var map = {
	"./Elektrische boilers.svg": "84bc",
	"./Elektrische schema's.svg": "4619",
	"./Keuring.svg": "82a0",
	"./Laadpalen.svg": "ba88",
	"./Nieuwbouw.svg": "4cbf",
	"./Renovatie.svg": "4c22",
	"./Tijdelijke aansluiting/werfkast.svg": "065f",
	"./Zelfbouw met begeleiding.svg": "663a",
	"./Zonnepanelen.svg": "d168",
	"./plug-solid.svg": "b1c7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";